import { createStore } from "redux";

const initialState: ReduxState = {
  sidebarShow: "responsive",
};

const changeState = (state = initialState, { type, ...rest }: { type: string }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
